howspace.components.pictureUploader = (() => {
    'use strict';

    const handleUploadCompleted = (e) => {
        const uploadedFile = e.detail.uploadedFiles[0];
        const fileUploader = $(e.target);
        const pictureUploader = fileUploader.closest('.howspace-picture-uploader');

        // Set the uploaded file id
        const uploadedFileIdInput = pictureUploader.find('input[type="hidden"]');
        uploadedFileIdInput.val(uploadedFile.id);

        // Show the preview
        const preview = pictureUploader.find('.preview');
        real.ajax.html(real.baseUri + '/uploadedfile/' + uploadedFile.id + '/component', {
            type : 'GET',
            success : function(html) {
                preview.find('.attachment').html(html);
                preview.removeClass('d-none');
                howspace.components.init(preview);
            }
        });

        // Hide the file uploader
        fileUploader.addClass('d-none');
        howspace.components.fileUploader.reset(fileUploader);
    };

    const handleDelete = (e) => {
        const btn = $(e.target);
        const pictureUploader = btn.closest('.howspace-picture-uploader');
        const fileUploader = pictureUploader.find('.howspace-file-uploader');

        // Clear the uploaded file id
        const uploadedFileIdInput = pictureUploader.find('input[type="hidden"]');
        uploadedFileIdInput.val('');

        // Hide the preview
        const preview = pictureUploader.find('.preview');
        preview.addClass('d-none');
        preview.find('.attachment').html('');

        // Show the file uploader
        fileUploader.removeClass('d-none');
    };

    return {
        init: elem => {
            elem.findIncludingSelf('.howspace-picture-uploader:not(.howspace-picture-uploader-initialized)').each(function () {
                const pictureUploader = $(this);

                pictureUploader.addClass('howspace-picture-uploader-initialized');

                pictureUploader[0].addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, handleUploadCompleted);

                pictureUploader.find('.howspace-picture-uploader-delete-btn').on('click', handleDelete);
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-picture-uploader.howspace-picture-uploader-initialized').each(function () {
                const pictureUploader = $(this);

                pictureUploader.removeClass('howspace-picture-uploader-initialized');

                pictureUploader[0].removeEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, handleUploadCompleted);

                pictureUploader.find('.howspace-picture-uploader-delete-btn').off('click', handleDelete);
            });
        }
    };
})();
